import rootService from 'core/services.root';

export default rootService({
    fetchAbsenceRateData: ['GET', '/admin/absence-rate/statistics'],
    fetchAbsenceRateDataMonthly: ['GET', '/admin/absence-rate/monthly/statistics'],
    fetchAbsenceReportsData: ['GET', '/admin/absence-reports'],
    fetchAbsenceReportsPage: ['GET', '/admin/professionals/absence-reports'],
    fetchAbsencesActiveData: ['GET', '/admin/active-absences?one_page=1'],
    fetchAbsencesByLicenseData: ['GET', '/admin/license/absences'],
    fetchAbsencesByLicenseMonthlyData: ['GET', '/admin/license/monthly/absences'],
    fetchAppointmentListing: ['GET', '/appointment/listing/all'],
    fetchAppointmentStatistics: ['GET', '/appointment/statistics'],
    fetchDiagnosisData: ['GET', '/admin/diagnoses'],
    fetchDiagnosisGroupedData: ['GET', '/admin/diagnoses/grouped'],
    fetchGeneralData: ['GET', '/admin/general'],
    fetchHealthSurveys: ['GET', '/admin/survey/health/statistics'],
    fetchHealthSurveysDownload: ['GET', '/admin/survey/health/statistics/details'],
    fetchLicensesData: ['GET', '/admin/professionals/licenses?one_page=1'],
    fetchLicensesDownload: ['GET', '/admin/professionals/licenses/details'],
    fetchLicensesGrantedData: ['GET', '/admin/license/granted'],
    fetchLicensesHealthIndexData: ['GET', '/admin/license/health-index'],
    fetchLicensesSummary: ['GET', '/admin/license/summary'],
    fetchPatientAttentionsData: ['GET', '/admin/patient/attentions'],
    fetchPatientAttentionsDownload: ['GET', '/admin/patient/attentions/details'],
    fetchPreworksData: ['GET', '/admin/prework/statistics'],
    fetchPreworksDownloadData: ['GET', '/admin/prework/statistics/detail?one_page=1'],
    fetchProfessionalsData: ['GET', '/admin/professionals'],
    fetchProfessionalsDownload: ['GET', '/admin/professionals/details'],
    fetchPsychosocialRisk: ['GET', '/admin/survey/psychosocial/statistics'],
    fetchPsychosocialRiskDownload: ['GET', '/admin/survey/psychosocial/answers'],
    fetchQuizzes: ['GET', '/admin/survey/quiz/statistics'],
    fetchQuizzesDownload: ['GET', '/admin/survey/quiz/statistics/details'],
    fetchRecipeRequests: ['GET', '/admin/recipe-request/statistics'],
    fetchRecipeRequestsDownload: ['GET', '/admin/recipe-request/statistics/detail?one_page=1'],
    fetchRecommendationsData: ['GET', '/admin/recommendations'],
    fetchRiskFactorsData: ['GET', '/admin/patient/risk-factors'],
    fetchRiskFactorsPage: ['GET', '/admin/patient/risk-factors/details'],
    fetchSessionsData: ['GET', '/admin/professionals/sessions'],
    fetchSurveysData: ['GET', '/admin/ratings'],
    fetchSurveysDownloadData: ['GET', '/admin/ratings/details'],
    fetchSymptomsData: ['GET', '/admin/symptoms'],
    fetchVideocallData: ['GET', '/admin/videocall']
});
